// extracted by mini-css-extract-plugin
export default {"container":"wR5_Qs"};